module.exports = __webpack_public_path__ + "media/images/job-templates-empty-e9dd5cdc4086ae1aa12e8d516360b1e9.svg";